<template>
  <el-main class="page-content-margin-unset">
    <div class="table-top dk-li">
      <el-input
        placeholder="请输入用户昵称/手机号/订单号进行搜索"
        v-model="body.keyword"
        clearable
        @change="handleCurrentChange()"
        class="input-with-select dk_input">
        <el-button
          @click="handleCurrentChange()"
          slot="append"
          icon="el-icon-search"/>
      </el-input>
      <span style="line-height: 40px;margin-right:10px">创建时间</span>
      <el-date-picker
        style="width:240px"
        clearable
        value-format="yyyy-MM-dd"
        @change="onTimeChange()"
        v-model="times"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"/>
      <span style="line-height: 40px;margin-right:10px">支付时间</span>
      <el-date-picker
        style="width:240px"
        clearable
        value-format="yyyy-MM-dd"
        @change="onTimeChange1()"
        v-model="times1"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"/>
      <div/>
      <el-select
        class="dk-select"
        v-model="body.pay_type"
        clearable
        placeholder="支付方式"
        @change="handleCurrentChange()">
        <el-option
          label="支付宝"
          value="2"/>
        <el-option
          label="微信"
          value="1"/>
        <el-option
          label="线下"
          value="3"/>
      </el-select>
      <div>
        <el-button
          type="primary"
          plain
          @click="event().toExportClick()">
          导出Excel
        </el-button>
        <a
          ref="export"
          style="display:none"
          :href="url"/>
      </div>
    </div>
    <el-radio-group
      class="dk-li"
      v-model="body.status"
      @change="handleCurrentChange()">
      <el-radio-button
        :label="item.value"
        v-for="(item,index) in orderArr"
        :key="index">{{ item.label }}</el-radio-button>
    </el-radio-group>
    <!-- 表格 -->
    <el-table
      border
      :data="tableData">
      <el-table-column
        prop="order_id"
        label="订单号"/>
      <el-table-column
        prop="create_time"
        label="创建时间"/>
      <el-table-column
        prop="name"
        label="用户昵称"/>
      <el-table-column
        prop="mobile"
        label="手机号"/>
      <el-table-column
        prop="money"
        label="订单金额"/>
      <el-table-column
        prop="paid_money"
        label="实际支付金额"/>
      <el-table-column
        prop="pay_type"
        label="支付方式">
        <template slot-scope="scope">
          <span>{{ ['','微信','支付宝','线下支付'][scope.row.pay_type] }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="pay_time"
        label="支付时间"/>
      <el-table-column
        prop="status"
        label="订单状态"/>
      <el-table-column
        prop="invite_code"
        label="推荐人ID"/>
      <el-table-column
        fixed="right"
        label="管理"
        width="440">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            class="mini-el-button"
            @click="event().toDetailClick(scope.row.order_uuid)">
            详 情
          </el-button>
          <el-button
            size="mini"
            type="warning"
            v-if="scope.row.status == '待支付'"
            @click="event().onChangMoneyClick(scope.row)">
            修改实际支付金额
          </el-button>
          <el-button
            size="mini"
            type="warning"
            class="mini-el-button"
            v-if="scope.row.status == '待支付' && scope.row.pay_type == 3 && scope.row.pay_type == 3"
            @click="event().onOfflinePayClick(scope.row.order_uuid)">
            确认到账
          </el-button>
          <el-button
            v-if="scope.row.status == '待发货'"
            size="mini"
            type="primary"
            class="mini-el-button"
            @click="event().onDeliveryClick(scope.row.order_uuid)">
            确认发货
          </el-button>
          <el-button
            v-if="scope.row.status == '待收货'"
            size="mini"
            type="success"
            class="mini-el-button"
            @click="event().onConfirmClick(scope.row.order_uuid)">
            确认收货
          </el-button>
          <el-button
            v-if="scope.row.status == '待支付' || scope.row.status == '待发货'"
            size="mini"
            type="danger"
            class="mini-el-button"
            @click="event().onCloseRefundOrderClick(scope.row)">
            关闭订单
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <div class="pagination-center">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="body.page_index"
        :page-size="body.page_size"
        layout="prev, pager, next"
        :total="total"/>
    </div>

    <!-- 发货 -->
    <el-dialog
      width="480px"
      :title="deliveryTitle"
      :visible.sync="deliveryDialog">
      <el-form
        :model="deliver"
        label-position="left"
        :rules="rules2"
        ref="ruleForm2"
        label-width="120px"
        class="demo-ruleForm">
        <el-form-item
          label="物流单号："
          prop="logistics_num">
          <el-input
            class="dk-input"
            v-model="deliver.logistics_num"/>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer">
        <el-button @click="deliveryDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="event().onSureClick('ruleForm2')">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 修改实际金额 -->
    <el-dialog
      width="480px"
      title="修改金额"
      :visible.sync="changeMoneyDialog">
      <el-form
        :model="changeMoneyBody"
        label-position="left"
        :rules="rules3"
        ref="ruleForm3"
        label-width="120px"
        class="demo-ruleForm">
        <el-form-item
          label="实际支付金额："
          prop="paid_money">
          <el-input
            class="dk-input"
            v-model.number="changeMoneyBody.paid_money"/>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer">
        <el-button @click="changeMoneyDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="event().onSureChangeMoneyClick('ruleForm3')">确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
import {
  getOrderList, closeRefundOrder, offlinePayOrder,
  closeCancelOrder, deliveryOrder, confirmOrder, getExportUrl, chengMoney,
} from '../../api/order'
import { imgDomain, exportApi } from '../../configs/env'
import commoonFunction from '../../mixins/common'

export default {
  mixins: [commoonFunction],
  data() {
    // eslint-disable-next-line
    const checkMoney = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('支付金额不能为空'));
      }
      if (!Number.isInteger(value)) {
        callback(new Error('请输入数字值'));
      } else {
        callback();
      }
    };
    return {
      url: '',
      deliveryTitle: '确认发货',
      deliveryDialog: false,
      changeMoneyDialog: false,
      imgDomain,
      orderArr: [
        {
          label: '全部',
          value: '',
        },
        {
          label: '待支付',
          value: '待支付',
        },
        {
          label: '待发货',
          value: '待发货',
        },
        {
          label: '待收货',
          value: '待收货',
        },
        {
          label: '已完成',
          value: '已完成',
        },
        {
          label: '已关闭',
          value: '已关闭',
        },
      ],
      body: {
        page_index: 1,
        page_size: 20,
        pay_type: '',
        create_begin_time: '',
        create_end_time: '',
        pay_begin_time: '',
        pay_end_time: '',
        status: '',
        keyword: '',
      },
      changeMoneyBody: {
        paid_money: '',
      },
      times: [],
      times1: [],
      total: 0,
      tableData: [
      ],
      rules2: {
        logistics_num: [
          { required: true, message: '请输入物流单号', trigger: 'blur' },
        ],
      },
      rules3: {
        paid_money: [
          { validator: checkMoney, trigger: 'blur' },
        ],
      },
      deliver: {
        logistics_num: '',
        uuid: '',
      },
    };
  },

  components: {
  },
  created() {
    this.network().getOrderList()
  },
  methods: {
    handleCurrentChange() {
      this.network().getOrderList()
    },
    onTimeChange() {
      // eslint-disable-next-line
      const [create_begin_time, create_end_time] = this.times?this.times:['','']
      this.body = Object.assign({}, this.body, { create_begin_time, create_end_time })
      this.handleCurrentChange()
    },
    onTimeChange1() {
      // eslint-disable-next-line
      const [pay_begin_time, pay_end_time] = this.times1?this.times1:['','']
      this.body = Object.assign({}, this.body, { pay_begin_time, pay_end_time })
      this.handleCurrentChange()
    },
    event() {
      return {
        toDetailClick: (uuid) => {
          this.$router.push({ path: 'detail', query: { uuid } })
        },
        // eslint-disable-next-line
        onCloseRefundOrderClick: ({ order_uuid, status }) => {
          if (status === '待支付') {
            this.isDel('确定关闭该待支付订单, 是否继续?', 'closeCancelOrder', { uuid: order_uuid })
          } else {
            this.isDel('确定关闭该待发货订单, 是否继续?', 'closeRefundOrder', { uuid: order_uuid })
          }
        },
        onOfflinePayClick: (uuid) => {
          this.network().offlinePayOrder({ uuid })
        },
        onDeliveryClick: (uuid) => {
          this.deliver = { uuid, logistics_num: '' }
          this.deliveryDialog = true
        },
        onConfirmClick: (uuid) => {
          this.isDel('确定收货, 是否继续?', 'confirmOrder', { uuid })
        },
        onSureClick: (formName) => {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.network().deliveryOrder()
            } else {
              console.log('error submit!!');
            }
          });
        },
        onSureChangeMoneyClick: (formName) => {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.network().chengMoney()
            } else {
              console.log('error submit!!');
            }
          });
        },
        toExportClick: () => {
          this.network().getExportUrl()
        },
        onChangMoneyClick: (row) => {
          this.changeMoneyBody.paid_money = row.paid_money
          this.changeMoneyBody.uuid = row.order_uuid
          this.changeMoneyDialog = true
        },
      }
    },
    network() {
      return {
        getOrderList: async () => {
          const { status, data } = await getOrderList(this.body)
          if (status !== 200) return
          this.tableData = data.data
          this.total = data.total
        },
        closeCancelOrder: async (body) => {
          const { status } = await closeCancelOrder(body)
          if (status !== 200) return
          this.network().getOrderList()
          this.$notify({
            title: '关闭成功',
            message: '关闭待支付订单成功',
            type: 'success',
          });
        },
        closeRefundOrder: async (body) => {
          const { status } = await closeRefundOrder(body)
          if (status !== 200) return
          this.network().getOrderList()
          this.$notify({
            title: '关闭成功',
            message: '关闭待发货订单成功',
            type: 'success',
          });
        },
        offlinePayOrder: async (uuid) => {
          const { status } = await offlinePayOrder(uuid)
          if (status !== 200) return
          this.network().getOrderList()
          this.$notify({
            title: '确认到账',
            message: '订单确认到账成功',
            type: 'success',
          });
        },
        confirmOrder: async (uuid) => {
          const { status } = await confirmOrder(uuid)
          if (status !== 200) return
          this.network().getOrderList()
          this.$notify({
            title: '确认收货',
            message: '订单确认收货成功',
            type: 'success',
          });
        },
        deliveryOrder: async () => {
          const { status } = await deliveryOrder(this.deliver)
          if (status !== 200) return
          this.network().getOrderList()
          this.deliveryDialog = false
          this.$notify({
            title: '发货成功',
            message: '订单发货成功',
            type: 'success',
          });
        },
        chengMoney: async () => {
          const { status } = await chengMoney(this.changeMoneyBody)
          if (status !== 200) return
          this.network().getOrderList()
          this.changeMoneyDialog = false
          this.$notify({
            title: '修改成功',
            message: '实际金额修改成功',
            type: 'success',
          });
        },
        getExportUrl: async () => {
          const { status, data } = await getExportUrl(this.body)
          if (status !== 200) return
          this.url = exportApi + data.path
          this.$nextTick(() => {
            this.$refs.export.click()
          })
        },
      }
    },
    handler() {
      return {
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/mixins.scss';
.table-top{
  @include dk-table-top;
}
</style>



// WEBPACK FOOTER //
// src/vuepage/order/list.vue